import { render, staticRenderFns } from "./scanInputOutTask.vue?vue&type=template&id=ec9ad684&scoped=true&"
import script from "./scanInputOutTask.vue?vue&type=script&lang=js&"
export * from "./scanInputOutTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9ad684",
  null
  
)

export default component.exports